export const GET_FIXTURE_BY_ID = "GET_FIXTURE_BY_ID";
export const GET_FIXTURE_BY_ID_RESPONSE_SUCCESS =
  "GET_FIXTURE_BY_ID_RESPONSE_SUCCESS";

export const GET_LIVE_FIXTURE_BY_ID = "GET_LIVE_FIXTURE_BY_ID";
export const GET_LIVE_FIXTURE_BY_ID_RESPONSE_SUCCESS =
  "GET_LIVE_FIXTURE_BY_ID_RESPONSE_SUCCESS";
